import { ReadOnlySelectorOptions, ReadWriteSelectorOptions, RecoilState, RecoilValueReadOnly, selector } from 'recoil';

export function recoilSelector<T>(options: ReadWriteSelectorOptions<T>): RecoilState<T>;

export function recoilSelector<T>(options: ReadOnlySelectorOptions<T>): RecoilValueReadOnly<T>;

export function recoilSelector<T>(options: ReadWriteSelectorOptions<T> | ReadOnlySelectorOptions<T>) {
  return selector<T>({
    cachePolicy_UNSTABLE: {
      // Only store the most recent set of dependencies and their values
      eviction: 'most-recent',
    },
    ...options,
  });
}
